import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTipLightbulb = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#3c3c3c",
	xmlns: "http://www.w3.org/2000/svg",
	overflow: "visible",
	preserveAspectRatio: "none",
	viewBox: "0 0 50 50",
	width: 24,
	height: 24,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1, 1)",
		children: /* @__PURE__ */ _jsx("path", { d: "m44.35 19.65-1.15-2.5L40.7 16l2.5-1.15 1.15-2.5 1.15 2.5L48 16l-2.5 1.15ZM38 10.9l-1.75-3.7-3.7-1.75 3.7-1.75L38 0l1.75 3.7 3.7 1.75-3.7 1.75ZM18 44q-1.7 0-2.875-1.175T13.95 39.95h8.1q0 1.7-1.175 2.875T18 44Zm-8.1-7.15v-3h16.2v3Zm.25-6.05q-3.3-2.15-5.225-5.375Q3 22.2 3 18.15q0-6.1 4.45-10.55Q11.9 3.15 18 3.15q6.1 0 10.55 4.45Q33 12.05 33 18.15q0 4.05-1.9 7.275-1.9 3.225-5.25 5.375Zm1.1-3H24.8q2.4-1.6 3.8-4.15 1.4-2.55 1.4-5.5 0-4.95-3.525-8.475Q22.95 6.15 18 6.15q-4.95 0-8.475 3.525Q6 13.2 6 18.15q0 2.95 1.4 5.5t3.85 4.15Zm6.75 0Z" })
	})
});
export default SvgTipLightbulb;
